import {useHistory} from 'react-router-dom'
import {ICompanyEnum, companies} from '@bdswiss/common-enums'
import {PopupProps} from '../../../../../../../../types'
import messages from '../../../../../../../../assets/messages'
import {AlertDialog} from '../../../../../../../Common/Dialog'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import {Trans, withNamespaces} from 'react-i18next'
import {TAUROMARKETS_MAURITIUS_SUPPORT_EMAIL, TAUROMARKETS_SUPPORT_EMAIL} from '../../../../constants'

type PammInvestorTransferNeededPopupProps = PopupProps & {
  linkedForexAccountId: number
  company: ICompanyEnum
}

const agreeI18nKey: string = 'transfer'
const disagreeI18nKey: string = 'cancel'
const titleI18nKey = 'pammInvestorTransferNeededTitle'

const _PammInvestorTransferNeededPopup = ({
  linkedForexAccountId,
  onClose,
  open,
  t,
  company,
}: PammInvestorTransferNeededPopupProps) => {
  const history = useHistory()
  const title = t(messages[titleI18nKey].i18nKey, messages[titleI18nKey].defaults)

  const handleTransfer = () => {
    history.push(`/transactions/${linkedForexAccountId}/transfer/transferFunds`)
  }

  const agreeText: string = t(messages[agreeI18nKey].i18nKey, messages[agreeI18nKey].defaults).toLocaleUpperCase()
  const disagreeText: string = t(messages[disagreeI18nKey].i18nKey, messages[disagreeI18nKey].defaults).toLocaleUpperCase()
  const email = company.value === companies.tauroMarketsMauritius.value
    ? TAUROMARKETS_MAURITIUS_SUPPORT_EMAIL
    : TAUROMARKETS_SUPPORT_EMAIL

  return (
    <AlertDialog
      agreeText={agreeText}
      disagreeText={disagreeText}
      onAgree={handleTransfer}
      onClose={onClose}
      onDisagree={onClose}
      open={open}
      title={title}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="subtitle2" align='center'>
            <Trans
              {...messages.pammInvestorTransferNeededLine1}
            />
          </Typography>
          &nbsp;
          <Typography variant="subtitle2" align="center">
            <Trans
              {...messages.pammInvestorTransferNeededLine2}
              components={[
                <a href={`mailto:${email}`}>{email}</a>,
              ]}
              values={{
                supportEmail: email,
              }}
            />
          </Typography>
        </Grid>
      </Grid>
    </AlertDialog>
  )
}

export const PammInvestorTransferNeededPopup = withNamespaces()<PammInvestorTransferNeededPopupProps>(
  _PammInvestorTransferNeededPopup
)
